import { render, staticRenderFns } from "./CandidateCreate.vue?vue&type=template&id=f92bf896&scoped=true&lang=pug&"
import script from "./CandidateCreate.vue?vue&type=script&lang=js&"
export * from "./CandidateCreate.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCreate.vue?vue&type=style&index=0&id=f92bf896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92bf896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
